/*
  PDP new (WIP), desktop and tablet only (template product.pdp-new, 768px and up):
  moves the "Seamlessly auto-syncs with" calendar block and the mini review slider
  out of the buy box and under the product gallery, so the two columns are closer in height.
  On phones everything stays in its original place.
*/
(function () {
  /* The new PDP runs on product.pdp-new and, from the Nov 2026 launch, on product.hearth-display */
  function isNewPdp() {
    var c = document.body.classList;
    return c.contains('template-product.pdp-new') || c.contains('template-product.hearth-display');
  }
  function init() {
    if (!isNewPdp()) return;
    var media = document.querySelector('.product__media');
    var wrap = media && media.querySelector('.pg-wrap');
    if (!wrap) return;

    var targets = [
      document.querySelector('.product__info .rev-calendar-icon-block'),
      document.querySelector('.product__info .cai-review-slider-mini')
    ].filter(Boolean);
    if (!targets.length) return;

    var items = targets.map(function (el) {
      var marker = document.createComment('pdp-under-gallery-origin');
      el.parentNode.insertBefore(marker, el);
      return { el: el, marker: marker };
    });

    var holder = document.createElement('div');
    holder.className = 'pdp-under-gallery';
    wrap.insertAdjacentElement('afterend', holder);

    var mq = window.matchMedia('(min-width: 768px)');
    function place() {
      if (mq.matches) {
        media.style.flexDirection = 'column';
        wrap.style.width = '100%';
        /* Kept tight to the thumbnails so the calendar logos show while shoppers browse the photos */
        holder.style.cssText = 'width:100%;margin-top:8px;';
        items.forEach(function (it) { holder.appendChild(it.el); });
        if (items[0]) { items[0].el.style.paddingTop = '12px'; }
      } else {
        media.style.flexDirection = '';
        wrap.style.width = '';
        holder.style.cssText = 'display:none;';
        if (items[0]) { items[0].el.style.paddingTop = ''; }
        items.forEach(function (it) { it.marker.parentNode.insertBefore(it.el, it.marker.nextSibling); });
      }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
  }

  /* PDP new (WIP), all widths: move the trust bullets (trial, warranty, shipping) from under the
     price to under Add to cart. The membership line stays next to the price. */
  function moveTrustBullets() {
    if (!isNewPdp()) return;
    var info = document.querySelector('.product__info');
    var list = info && info.querySelector('.price-props-list');
    if (!list) return;
    var bullets = Array.prototype.filter.call(list.children, function (li) {
      return li.tagName === 'LI' && !li.querySelector('.subscription-popup');
    });
    if (!bullets.length) return;
    var anchor = info.querySelector('.product__holiday-note') || info.querySelector('form[id^="add-to-cart-form"]');
    if (!anchor) return;
    var trust = document.createElement('ul');
    trust.className = 'pdp-trust-list';
    bullets.forEach(function (li) { trust.appendChild(li); });
    anchor.insertAdjacentElement('afterend', trust);
  }
  function run() { init(); moveTrustBullets(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
